export default "__VITE_ASSET__DRue3yE$__"